var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg022Binoculars = function Svg022Binoculars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 271,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211 271c0-57.99-47.01-105-105-105S0 213.01 0 271s48.01 105 106 105 105-47.01 105-105m-165 0c0-33.091 26.909-60 60-60s60 26.909 60 60-26.909 60-60 60-60-26.909-60-60M301 166v-30h-90v30h30v28.444c-9.401-.765-18.691-1.983-27.477-4.191C230.536 212.84 241 240.606 241 271c0 17.805-3.653 34.728-9.943 50.305A63 63 0 0 1 256.439 316c8.201.051 16.62 2.159 24.725 6.019C274.699 306.255 271 289.067 271 271c0-30.392 10.463-58.158 27.473-80.744-8.782 2.206-18.073 3.42-27.473 4.186V166z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 271,
    r: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406 166c-57.99 0-105 47.01-105 105s47.01 105 105 105 106-47.01 106-105-48.01-105-106-105m0 165c-33.091 0-60-26.909-60-60s26.909-60 60-60 60 26.909 60 60-26.909 60-60 60"
  })));
};
export default Svg022Binoculars;